import React from 'react';
import { Link } from'react-router-dom';
import { Button, Card, Grid, Typography } from "@material-ui/core";

const PageNotFound = () => {
  return (
    <div >
      <Grid container justify="center" alignItems="center" style={{ height: '70vh' }}>
        <Grid item sm={10} xs={12} style={{ height: '100%' }}>
          <Card style={{ textAlign: 'center', height: '100%' }}>
            <Typography variant="h1">404</Typography>
            <Typography variant="h4">Page Not Found</Typography>
            <Link to='/menu'><Button variant="outlined" color="secondary">Take me to the food</Button></Link>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default PageNotFound;
